module.exports = __webpack_public_path__ + "static/media/advantages_3.56f63b17.svg";